// "club.actualizar" -> "Club actualizado", "usuario.crear" -> "Usuario creado"... una traducción
// sencilla y legible en vez de mostrar el código interno tal cual. Usado por AuditoriaPage y por
// el feed de actividad reciente del Dashboard.
const VERBOS: Record<string, string> = {
  crear: "creado",
  actualizar: "actualizado",
  desactivar: "desactivado",
  eliminar: "eliminado",
  bloquear: "bloqueada",
  login: "inició sesión",
  restablecer_contrasena: "restableció su contraseña",
  cambiar_contrasena: "cambió su contraseña",
  regenerar_token: "regeneró el enlace de",
  aprobar: "aprobado",
};

// Acciones cuyo texto no sale bien de la regla genérica "entidad + verbo".
const ACCIONES_ESPECIALES: Record<string, string> = {
  "campeonato_partido.crear": "Partido de campeonato creado",
  "campeonato_partido.actualizar": "Partido de campeonato actualizado",
  "campeonato_partido.eliminar": "Partido de campeonato eliminado",
  "campeonato_equipo.crear": "Pareja inscrita en un campeonato",
  "campeonato_equipo.actualizar": "Pareja de un campeonato actualizada",
  "campeonato_equipo.eliminar": "Pareja retirada de un campeonato",
  "campeonato_gestor.crear": "Gestión de campeonato concedida",
  "campeonato_gestor.eliminar": "Gestión de campeonato revocada",
  "registro_arbitro.aprobar": "Registro de árbitro aprobado",
};

export function describeAccion(accion: string): string {
  if (ACCIONES_ESPECIALES[accion]) return ACCIONES_ESPECIALES[accion];
  const [entidad, verbo] = accion.split(".");
  const verboLegible = VERBOS[verbo] ?? verbo;
  if (accion === "auth.login") return "Inició sesión";
  if (accion === "auth.restablecer_contrasena") return "Restableció su contraseña";
  return `${entidad.charAt(0).toUpperCase()}${entidad.slice(1)} ${verboLegible}`;
}
